var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-main"},[(_vm.message.type)?_c('div',{staticClass:"message-block"},[_c('full-page-message',{attrs:{"type":_vm.message.type,"message":_vm.message.text}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }